var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-units-tool",attrs:{"title":_vm.title}},[_c('input-units',_vm._b({on:{"change":_vm.onChange}},'input-units',{ value: _vm.value, units: _vm.units, size: 'small', disabled: !_vm.isEnabled, appendToBody: false },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }